export const RIDE = 'Ride';
export const MEALS = 'Meals (Coming Soon)';
export const DELIVERY = 'Delivery';

export const TYPES_OF_SERVICES = [RIDE, MEALS, DELIVERY];
